import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, onMounted } from "vue";
import DxDateBox from "devextreme-vue/date-box";
import DxSelectBox from "devextreme-vue/select-box";
import ProComenziService from "@/services/Comercial/ProComenzi";

interface Filter {
  category: number | null;
  start: string;
  end: string;
}

const STORAGE_KEY = 'filtre-comenzi';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterComenzi',
  emits: ["filtersChanged"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

function loadSaved(): { category: number | null; start: Date | null; end: Date | null } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { category: null, start: null, end: null };
    const parsed = JSON.parse(raw);
    return {
      category: parsed.category ?? null,
      start: parsed.start ? new Date(parsed.start) : null,
      end: parsed.end ? new Date(parsed.end) : null,
    };
  } catch {
    return { category: null, start: null, end: null };
  }
}

function savedOrDefault() {
  const saved = loadSaved();
  const now = new Date();
  return {
    category: saved.category,
    start: saved.start ?? new Date(now.getFullYear(), now.getMonth(), 1),
    end: new Date(),
  };
}

const initial = savedOrDefault();
const selectedCategory = ref<number | null>(initial.category);
const categories = ref<any[]>([]);
const dataStart = ref<Date | null>(initial.start);
const dataEnd = ref<Date | null>(initial.end);


// Funcție de formatare ISO yyyy-MM-dd
function formatDate(d: Date | null) {
  return d ? d.toISOString().split("T")[0] : "";
}

// Emitere filtre
function applyFilters() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    category: selectedCategory.value,
    start: dataStart.value?.toISOString() ?? null,
    end: dataEnd.value?.toISOString() ?? null,
  }));
  emit("filtersChanged", {
    category: selectedCategory.value !== null ? Number(selectedCategory.value) : null,
    start: formatDate(dataStart.value),
    end: formatDate(dataEnd.value),
  });
}

// Aplică automat filtrele la orice schimbare (fără buton "Caută").
watch([selectedCategory, dataStart, dataEnd], applyFilters);

// Încărcare categorii + aplicare filtre implicite
onMounted(async () => {
  const resp = await ProComenziService.getCategoriiPermise();
  categories.value = resp.data ?? [];
  if (selectedCategory.value === null && categories.value.length > 0)
    selectedCategory.value = categories.value[0].TipComanda;
  applyFilters();
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    dense: "",
    align: "center",
    class: "mb-0 filtre-comenzi-row"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxSelectBox), {
            modelValue: selectedCategory.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCategory).value = $event)),
            items: categories.value,
            "display-expr": "Denumire",
            "value-expr": "TipComanda",
            placeholder: "Categorie",
            "search-enabled": true,
            "search-expr": "Denumire"
          }, null, 8, ["modelValue", "items"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "2"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxDateBox), {
            modelValue: dataStart.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataStart).value = $event)),
            type: "date",
            "display-format": "yyyy-MM-dd",
            "show-clear-button": "true",
            placeholder: "Start"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        sm: "2"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxDateBox), {
            modelValue: dataEnd.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataEnd).value = $event)),
            type: "date",
            "display-format": "yyyy-MM-dd",
            "show-clear-button": "true",
            placeholder: "End",
            min: dataStart.value
          }, null, 8, ["modelValue", "min"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})